import { api } from "api/api";
import { AxiosError } from "axios";
import Atividade from "model/gestao/atividades/Atividade";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class AtividadeService implements BaseServiceCadastros<Atividade> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/atividade/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Atividade>((resolve, reject): void => {
            api
                .get(`/atividade/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(atividade: Atividade) {
        return new Promise<Atividade>((resolve, reject): void => {
            api
                .post(`/atividade/incluir`, JSON.stringify(atividade))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(atividade: Atividade) {
        return new Promise<Atividade>((resolve, reject): void => {
            api
                .put(`/atividade/editar`, JSON.stringify(atividade))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/atividade/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getCobrancaFilter() {
        return [
            { label: 'Sim', value: true },
            { label: 'Não', value: false }
        ]
    }

}

export default AtividadeService;
